import { MultiSelector } from 'components/MultiSelector';
import { type CSSProperties, type FC} from 'react';
import {type NestedFund, type NestedOrganization } from 'types';

type FundSelectorProps = {
  availableData: NestedOrganization,
  selectedFundIds: string[],
  setSelectedFundIds: React.Dispatch<React.SetStateAction<string[]>>,
  style?: CSSProperties,
};

const getOptions = (funds: NestedFund[]) => {
  const fundOptions = funds.map((fund) => {
    return {display: fund.fundName,
      id: fund.fundId,
    };
  });

  return fundOptions;
};

const FundSelector: FC<FundSelectorProps> =
({availableData, selectedFundIds, setSelectedFundIds, style}: FundSelectorProps) => {
  const checkFund = (fundIds: string[]) => {
    setSelectedFundIds(fundIds);
  };

  return (
    <MultiSelector
      dataSelectionValue='download-files-select-filters-fund-dropdown'
      description='Select funds'
      disabled={!getOptions(availableData?.funds).length}
      onOption={checkFund}
      optionList={getOptions(availableData.funds)}
      placeholder='funds'
      selectedIds={selectedFundIds}
      style={style || { width: '250px' }}
      title='Fund'
    />
  );
};

export { FundSelector };
